import 'babel-polyfill'

import Vue from 'vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

import App from './App.vue'

import HelperMixin from './mixins/Helper'
import formRulesMixin from './mixins/FormRules'

Vue.mixin(HelperMixin)
Vue.mixin(formRulesMixin)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
